import { Box, Grid, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import layer from '../../../Assets/Icons/Dashboard/layer-group.svg';
import { AppColors } from '../../../Utils/helper/AppColors';

export const DetailedCard = ({ heading, src, data }) => {
	return (
		<>
			{/* // <Grid
		// 	item
		// 	xs={12} // Full width on extra small screens
		// 	sm={6} // Two cards per row on small screens
		// 	md={3} // Four cards per row on medium and larger screens
		// > */}
			<Paper
				elevation={1}
				sx={{
					// height: '134px',
					px: 1.5,
					py: 2,
					pb: '30px',
					borderRadius: '10px',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
					border: `1px solid ${AppColors.BORDER_SECONDARY}`,
					boxShadow: '0px 4px 14px #68686840',
				}}
			>
				<Stack direction="row" alignItems="flex-start" mb={'4px'} gap={0}>
					{/* <Avatar alt={src} src={src} sx={{ width: 24, height: 24 }} /> */}

					<Typography
						sx={{ flexWrap: 'none' }}
						fontSize={14}
						fontWeight={500}
						lineHeight={'150%'}
						fontFamily={'Inter'}
						color={AppColors.grey_text}
					>
						{heading}
					</Typography>
				</Stack>

				<Box>
					{data.map((item, idx) => (
						<Stack
							direction={'row'}
							alignItems="center"
							gap={1}
							key={idx}
							sx={{ display: 'flex', mt: idx > 0 ? 1 : 0  }}
						>
							{/* <Typography fontSize={14} fontWeight={600} lineHeight={'150%'} fontFamily={'Poppins'} color={AppColors.LIGHT_GRAY}>
								{item.label}:
							</Typography> */}
							<Typography
								fontSize={idx == 0 ? 24 : 14}
								fontWeight={idx === 0 ? 'bold' : 500}
								lineHeight={'150%'}
								fontFamily={'Inter'}
								color={ idx == 0 ? AppColors.HEADING_TITLE : AppColors.grey_text}
							>
								{item.value} {item.per && '%'}
							</Typography>
						</Stack>
					))}
				</Box>
			</Paper>
			{/* </Grid> */}
		</>
	);
};


const DashBoardCards = ({ summaryData }) => {
	console.log('summary data in cards - ', summaryData);
	return (
		<Grid container spacing={2}>
			<Grid item xs={12} sm={6} md={4}>
				<DetailedCard 
					heading={'Completed Interviews'}
					src={layer}
					data={[
						{ label: 'Active', value: summaryData?.totalExits || '0' },
						{ label: 'Total', value: '' },
					]}
				/>
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<DetailedCard
					heading={'Avg. Sentiments'}
					src={layer}
					data={[
						{ label: 'Active', value: `${!!summaryData?.avgSentiment?.score5 ? Number(summaryData?.avgSentiment?.score5 ?? 0).toFixed(1) + '/5' : '0'}`  },
						{ label: 'Total', value: '' },
					]}
				/>
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<DetailedCard
					heading={'Scheduled Interviews'}
					src={layer}
					data={[
						{ label: 'Active', value: summaryData?.pendingReviews || '0' },
						{ label: 'Total', value: '' },
					]}
				/>
			</Grid>
		</Grid>
	);
};

export default DashBoardCards;
